import { useState, useMemo } from 'react';
import { parseHeadings } from '../utils/toc';

interface TableOfContentsProps {
  markdown: string;
}

export default function TableOfContents({ markdown }: TableOfContentsProps) {
  const [isOpen, setIsOpen] = useState(false);
  const headings = useMemo(() => parseHeadings(markdown), [markdown]);

  if (headings.length < 3) return null;

  return (
    <nav className="my-4 border border-border">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="w-full flex items-center justify-between px-3 py-2 text-sm font-bold text-accent hover:underline cursor-pointer"
      >
        <span>Table of Contents</span>
        <span className="text-muted text-xs">{isOpen ? '[hide]' : '[show]'}</span>
      </button>
      {isOpen && (
        <ul className="list-none px-3 pb-3 space-y-1 m-0">
          {headings.map((h, i) => (
            <li key={i} className={h.level === 3 ? 'ml-4' : ''}>
              <a
                href={`#${h.slug}`}
                className="text-sm text-accent hover:underline"
              >
                {h.text}
              </a>
            </li>
          ))}
        </ul>
      )}
    </nav>
  );
}
